import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

// Context
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext';

// Components
import Layout from './components/Layout';
import PrivateRoute from './components/PrivateRoute';
import ErrorBoundary from './components/ErrorBoundary';

// Pages
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import TicketList from './pages/TicketList';
import TicketDetail from './pages/TicketDetail';
import CreateTicket from './pages/CreateTicket';
import ProjectList from './pages/ProjectList';
import BranchList from './pages/BranchList';
import Reports from './pages/Reports';
import Profile from './pages/Profile';
import IncomingEmailInbox from './pages/IncomingEmailInbox';
import UsersAndTechnicians from './pages/UsersAndTechnicians';
import TelegramMiniApp from './pages/TelegramMiniApp';
import EmployeeBadges from './pages/EmployeeBadges';
import EmployeeBadgePrintPage from './pages/EmployeeBadgePrintPage';
import BadgeVerificationPage from './pages/BadgeVerificationPage';

const GuardedRoute = ({ children }) => (
  <PrivateRoute>
    {children}
  </PrivateRoute>
);



function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <NotificationProvider>
          <Router>
            <Routes>
            <Route path="/badge/verify/:token" element={<BadgeVerificationPage />} />
            <Route path="/employee-badges/:userId/print" element={<GuardedRoute><EmployeeBadgePrintPage /></GuardedRoute>} />
            <Route path="/telegram-app" element={<TelegramMiniApp />} />
            <Route path="/login" element={<Login />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<PrivateRoute><Navigate to="/dashboard" replace /></PrivateRoute>} />
              <Route path="dashboard" element={<GuardedRoute><Dashboard /></GuardedRoute>} />
              <Route path="tickets" element={<GuardedRoute><TicketList /></GuardedRoute>} />
              <Route path="tickets/:id" element={<GuardedRoute><TicketDetail /></GuardedRoute>} />
              <Route path="tickets/new" element={<GuardedRoute><CreateTicket /></GuardedRoute>} />
              <Route path="projects" element={<GuardedRoute><ProjectList /></GuardedRoute>} />
              <Route path="branches" element={<GuardedRoute><BranchList /></GuardedRoute>} />
              <Route path="incoming-emails" element={<GuardedRoute><IncomingEmailInbox /></GuardedRoute>} />
              <Route path="reports" element={<GuardedRoute><Reports /></GuardedRoute>} />
              <Route path="users" element={<GuardedRoute><UsersAndTechnicians /></GuardedRoute>} />
              <Route path="staff" element={<GuardedRoute><UsersAndTechnicians /></GuardedRoute>} />
              <Route path="employee-badges" element={<GuardedRoute><EmployeeBadges /></GuardedRoute>} />
              <Route path="profile" element={<PrivateRoute><Profile /></PrivateRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Router>
        </NotificationProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
}

export default App;
